(function() {
    'use strict';

    angular.module("imApp").factory("accountingBuntsComponentService", ['$ihttp', function ($ihttp) {
        let service = {
            getAccountingBunts: function (parms) {
                return $ihttp.post({
                    method: 1919,
                    parameters: parms || {}
                });
            },
            createNew: function (setting) {
                return $ihttp.post({
                    method: 1921,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();
